export const SET_GLOBAL_SEARCH_CODE = 'SET_GLOBAL_SEARCH_CODE';
export const SET_GLOBAL_SEARCH_TEXT = 'SET_GLOBAL_SEARCH_TEXT';
export const SET_GLOBAL_SEARCH_RESULTS = 'SET_GLOBAL_SEARCH_RESULTS';
export const SET_IS_SEARCHING_TRUE = 'SET_IS_SEARCHING_TRUE';
export const CLEAR_GLOBAL_SEARCH_RESULT_AND_TEXT = 'CLEAR_GLOBAL_SEARCH_RESULT_AND_TEXT';
export const SET_GLOBAL_SEARCH_LOADING = 'SET_GLOBAL_SEARCH_LOADING';
